var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPointBarcodeColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24H2v6h6v-2H4v-4zM2 8h2V4h4V2H2v6zM24 2v2h4v4h2V2h-6zM6 23h2V9H6v14z",
    fill: props.color
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.136 14.854a8.27 8.27 0 119.188 13.752 8.27 8.27 0 01-9.188-13.752zm1.172 11.998a6.16 6.16 0 106.844-10.243 6.16 6.16 0 00-6.844 10.243z",
    fill: "#BF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.66 25.494v-7.322h2.48a3.782 3.782 0 011.538.291c.418.175.774.47 1.023.85.25.403.374.87.36 1.345.015.47-.11.934-.36 1.333-.25.377-.607.673-1.023.85-.486.208-1.01.31-1.538.297h-.93v2.356h-1.55zm2.38-5.977h-.83v2.263h.83c.363.017.722-.076 1.03-.266a.956.956 0 00.39-.856.979.979 0 00-.39-.868 1.8 1.8 0 00-1.03-.273z",
    fill: "#BF0000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.54 23H10V9h4v5.97A10.268 10.268 0 0011.54 23zM26 12.39a10.27 10.27 0 00-3-.85V9h3v3.39zM19.024 11.823a10.27 10.27 0 012-.338V9h-2v2.823zM16 13.208l.025-.017c.622-.416 1.285-.76 1.975-1.029V9h-2v4.208z",
    fill: props.color
  }));
}

export default SvgIconPointBarcodeColor;